import { render, staticRenderFns } from "./iconCloud.vue?vue&type=template&id=4895ece5"
import script from "./iconCloud.vue?vue&type=script&lang=js"
export * from "./iconCloud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports